// 运行时配置
import RightContent from '@/components/RightContent/index';
import { history, useKeepOutlets } from '@umijs/max';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import React from 'react';
import { RequestConfig } from 'umi';
import defaultSettings from '../config/defaultSettings';
import '../node_modules/braft-editor/dist/index.css';
import './assets/css/common.less'; //公共css样式
import './assets/fonts/iconfont.css';
import './assets/fonts/iconfont.js';
import {
  TokRequestInterceptors,
  TokResponseInterceptor,
} from './utils/HttpUtil';
// 全局初始化数据配置，用于 Layout 用户信息和权限初始化
// 更多信息见文档：https://umijs.org/docs/api/runtime-config#getinitialstate
// const user = localStorage.getItem(
//   process.env.REACT_APP_CONFIG_ENV + '_boss_user_2',
// );
// export async function getInitialState(): Promise<{ name: any }> {
//   return { name: JSON.parse(user).nick };
// }
dayjs.locale('zh-cn');

export const layout = () => {
  return {
    logo: '/logo.svg',
    iconfontUrl: '/fonts/iconfont.js',
    menu: {
      locale: false,
    },
    token: {
      sider: {
        colorMenuBackground: '#001529',
        colorBgMenuItemHover: '#4682B4',
        colorBgMenuItemCollapsedHover: '#FFF2F0',
        colorBgMenuItemSelected: '#1890ff',
        colorTextMenu: '#fff',
        colorTextMenuSelected: '#fff',
        colorTextMenuActive: '#001529',
        colorTextMenuSecondary: '#001529',
        colorTextMenuItemHover: '#fff',
      },
      header: {
        colorBgHeader: '#001529',
        colorHeaderTitle: '#fff',
      },
    },
    layout: 'mix',
    fixedHeader: false,
    fixSiderbar: true,
    locale: 'zh-CN',
    contentWidth: 'Fluid',
    // title: '步甲科技-物流管理系统',
    settings: defaultSettings,
    childrenRender: (dom, props) => {
      //渲染多标签 keep-alive
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const element = useKeepOutlets();
      return element;
    },
    rightContentRender: () => RightContent(),
  };
};
export async function getInitialState(): Promise<any> {
  let currentUser = localStorage.getItem(
    process.env.REACT_APP_CONFIG_ENV + '_boss_user_2',
  );
  if (!currentUser) {
    history.replace({
      pathname: '/user/login' + location.search,
    });
  }

  return {
    currentUser: currentUser && JSON.parse(currentUser),
  };
}
export const request: RequestConfig = {
  errorConfig: {
    // errorHandler:errorHandler,
  },
  requestInterceptors: [TokRequestInterceptors],
  responseInterceptors: [TokResponseInterceptor as any],
};

export function rootContainer(container: React.ReactElement) {
  return React.createElement(ConfigProvider, { locale: zhCN }, container);
}
